export const WAT2WASM_BINARY_PATH = 'wat2wasm';
export const WAT2WASM_OPTIONS = ['--debug-names'];
export const OUTPUT_WAT_FILE_NAME = 'module.wat';
export const OUTPUT_WASM_FILE_NAME = 'module.wasm';

export const DEFAULT_HTTP_PORT = parseInt(globalThis.process?.env?.PORT) || 8000;
export const PACKAGE_CONFIG_FILE_NAME = 'lotus.toml';
export const CACHE_DIR_NAME = '.cache';

export const SERVER_REFRESH_RATE = 10;
export const SERVER_EXTERNAL_MODULES = ['ws', 'express'];
export const SERVER_CLIENT_FILES_PATH = 'public';

export const DEFAULT_ASSET_PROXY_BASE_PATH = '/proxy';
export const DEFAULT_WEBSOCKET_UPGRADE_PATH = '/ws';

export const ASSETS_DIR_NAME = 'assets';